import { CategoryProductsResponse } from './types/mapped';
import { DEFAULT_PAGE_SIZE } from './const';

interface EmptyProductListResponseOptions {
    itemsPerPage?: number;
    currentPage?: number;
    categoryDisplayName?: string;
}

/**
 * Returns a fresh empty CategoryProductsResponse. Used by data actions and services
 * to return a stable shape on error or when no results are available, instead of
 * throwing or returning undefined (which can crash SSR).
 */
export function createEmptyProductListResponse(options: EmptyProductListResponseOptions = {}): CategoryProductsResponse {
    return {
        categoryDisplayName: options.categoryDisplayName,
        productList: [],
        totalItems: 0,
        currentPage: options.currentPage ?? 1,
        itemsPerPage: options.itemsPerPage ?? DEFAULT_PAGE_SIZE,
        totalPages: 0
    };
}
